export default {
  label: {
    shop: 'Shop',
    selectedShop: 'Shop',
    selectedBrand: 'Brand',
    selectedCategory: 'Category',
    promoInfo: 'Promo Info',
    StorePromo: 'Store Promo',
    OtherPromo: 'Other Promo',
  },
  button: {
    filter: 'Filter',
    searchViaUpload: 'Search via upload',
    submit: 'Submit',
    favorite: 'Favorites',
    reset: 'Reset',
  },
  table: {
    image: 'Image',
    skuCode: 'SkuCode',
    name: 'Name',
    category: 'Category',
    brand: 'Brand',
    lPrice: 'Ret-Price',
    refPrice: 'Ref-Price',
    currency: 'USD',
    discount: 'Dis-Price',
    grade: 'Price Grading',
    status: 'Status',
    maxPriceShop: 'Max-Price Shop',
    topLPrice: 'Ret-Price',
    maxPrice: 'Dis-Price',
    minPriceShop: 'Min-Price Shop',
    lowLPrice: 'Ret-Price',
    minPrice: 'Dis-Price',
    operation: 'Operation',
    operationButton: 'view detail',
    chDescription: 'Description(CH)',
    enDescription: 'Description(EN)',
  },
  options: {
    sellingState: {
      all: 'Status',
      selling: 'Launched',
      soldOut: 'Sold out',
      offShelf: 'Removed',
    },
    currency: {
      USD: 'USD',
      CNY: 'CNY',
      THB: 'THB',
      EUR: 'EUR',
      HKD: 'HKD',
      SGD: 'SGD',
      AED: 'AED',
      JPY: 'JPY',
      AUD: 'AUD',
      MYR: 'MYR',
      MOP: 'MOP',
    },
    searchType: {
      keyword: 'Keyword',
      code: 'Code',
      upc: 'UPC',
      search: 'Search',
    },
  },
  filterModal: {
    title: 'Filter',
    brand: 'Brand',
    selected: 'Selected',
  },
  favoriteModal: {
    tips: {
      noSelect: 'please select a favorite group',
    },
    success: {
      noSelect: 'Successfully added！',
    },
  },
  copyFavoriteSelectModal: {
    title: 'Copy Favorite',
  },
  nameShowMsg: {
    text: 'Click to view the product page on the website',
  },
  refPrice: {
    text: 'Because the retailer website does not display the original price of the product, hence we use the price from other retailers as references',
  },
};
